module.exports = __webpack_public_path__ + "assets/img/user3.6d68bbb7.jpg";